export const eventEditorLocale = {
    'zh-CHS': {
        eventsEditor: {
            createInteractions: '新建交互事件',
            importControllers: '引入控制器',
            addNewMethods: '添加新方法',
            savedMethods: '已有方法',
            cancel: '取消',
            methodNotExist: '方法已被移除，请重新绑定',
            methodDeleted: '方法已被删除，请绑定其他方法',
            finish: '完成',
            targetComponent: '挂载到目标组件',
            allBound: '事件已全部绑定',
            noBoundEvents: '当前没有可绑定事件',
            controllerExist: '该控制器已存在',
            chooseSelect: '请选择需要绑定的方法',
            methodMoved: '方法已被移除，请重新绑定',
            methodAbandonedAndRebound: '方法已失效，请重新绑定',
            methodAbandoned: '该方法已失效',
            sureOfSavedMethods: '确认',
            cancelOfSavedMethods: '取消',
            tips: '该方法添加到的组件'
        },
    },
    'zh-CHT': {
        eventsEditor: {
            createInteractions: '新建交互事件',
            importControllers: '引入控制器',
            addNewMethods: '添加新方法',
            savedMethods: '已有方法',
            cancel: '取消',
            methodNotExist: '方法已被移除，請重新綁定',
            methodDeleted: '方法已被刪除，請綁定其他方法',
            finish: '完成',
            targetComponent: '掛載到目標組件',
            allBound: '事件已全部綁定',
            noBoundEvents: '當前沒有可綁定事件',
            controllerExist: '該控制器已存在',
            chooseSelect: '請選擇需要綁定的方法',
            methodMoved: '方法已被移除，請重新綁定',
            methodAbandonedAndRebound: '方法已失效，請重新綁定',
            methodAbandoned: '該方法已失效',
            sureOfSavedMethods: '確認',
            cancelOfSavedMethods: '取消',
            tips: '該方法添加到的組件'
        },
    },
    en: {
        eventsEditor: {
            createInteractions: 'Create Interactions',
            importControllers: 'Import Controllers',
            addNewMethods: 'Add New Methods',
            savedMethods: 'Saved Methods',
            cancel: 'Cancel',
            methodNotExist: 'The method has been moved, please rebind',
            methodDeleted: 'Method has been deleted, please bind other methods',
            finish: 'Finish',
            targetComponent: 'Mount to target component',
            allBound: 'Events all bound',
            noBoundEvents: 'No bindable events',
            controllerExist: 'Controller already exists',
            chooseSelect: 'Please select method that need to be bound',
            methodMoved: 'Method already moved, please rebind',
            methodAbandonedAndRebound: 'Method invalid, please rebind',
            methodAbandoned: 'Method invalid',
            sureOfSavedMethods: 'OK',
            cancelOfSavedMethods: 'Cancel',
            tips: 'The method added to the component'
        },
    }
};
